import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

import CN from '../Text/SmsStoppedText.module.scss';

const SmsStoppedText = () => {
  const { t } = useTranslation();
  return (
    <div className={CN.text} data-bem="SmsStoppedText">
      {t('composite.activityFeed.smsThread.optOutMessagePart1')}
      <br />
      {t('composite.activityFeed.smsThread.optOutMessagePart2')}
    </div>
  );
};

export default SmsStoppedText;
